<script setup>
import { ref } from "vue";
import DevicesTable from "@/components/Dashboard/Courses/Course/core/DevicesTable.vue";

const loading = ref(false);
</script>

<template>
  <div v-if="loading" class="d-flex justify-content-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div v-else>
    <DevicesTable />
  </div>
</template>
